import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import {
	DEFAULT_GATEWAY_EN,
	DEFAULT_GATEWAY_FR,
	LOCAL_STORAGE_KEY_PREFERRED_GATEWAY,
} from "../../../const/const";
import { usePageContext } from "../../../context/PageContext";
import { PageBanner } from "./PageBanner";
import { setBookingSearchBox } from "../../../connectors/SearchBoxConnector";
import { extractTransformationAndPublicIdSegment } from "../utils/extractTransformationAndPublicIDSegment";

const PageBannerConnector = ({ hotelData, merchandising }) => {
	const { locale } = usePageContext();
	const [price, setPrice] = useState();
	const galleryImages = hotelData?.HotelImages?.images
		?.filter(x => x.src)
		.map((img, index) => {
			const { publicId, baseUrl } = extractTransformationAndPublicIdSegment(img?.src);

			return {
				id: index,
				alt: hotelData.HotelName,
				public_id: publicId,
				width: 1200,
				// height: 675,
				baseUrl,
			};
		});

	useEffect(() => {
		if (merchandising) {
			let code = locale === "fr" ? DEFAULT_GATEWAY_FR : DEFAULT_GATEWAY_EN;

			const localStorageGatewayCode = JSON.parse(
				localStorage.getItem(LOCAL_STORAGE_KEY_PREFERRED_GATEWAY)
			);
			if (localStorageGatewayCode?.value) {
				code = localStorageGatewayCode?.value;
			}

			const _gateway = merchandising?.find(i => i?.gateway?.code === code);
			if (_gateway?.promotionGroups?.[0]?.offers?.length) {
				setPrice(_gateway.promotionGroups?.[0]?.offers?.[0]);
			}

			if (hotelData.SoftVoyageCode) {
				setBookingSearchBox({
					to: hotelData.SoftVoyageCode,
					force: true,
					isHotel: true,
				});
			}
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const bannerData = {
		tags: hotelData.Collections?.map((collection, index) => {
			const copyValues = Object.entries(collection)
				.filter(([key]) => key.startsWith("collectioncopy_"))
				.map(([, value]) => value);

			return {
				id: String(index + 1),
				label: collection.collectionName,
				content: copyValues.join(". \n"),
			};
		}),
		images: galleryImages,
		// Ratings
		numberOfReviews: hotelData.GuestExperience?.NumberOfReviews?.[0]?.NumberOfReviews,
		diningRating: parseFloat(hotelData.GuestExperience?.SectionRating?.[0]?.Dining ?? 0),
		diningRatingDescription: hotelData.GuestExperience?.SectionRatingDescription?.[0]?.Dining,
		poolRating: parseFloat(hotelData.GuestExperience?.SectionRating?.[0]?.Pool ?? 0),
		poolRatingDescription: hotelData.GuestExperience?.SectionRatingDescription?.[0]?.Pool,
		roomRating: parseFloat(hotelData.GuestExperience?.SectionRating?.[0]?.Accommodations ?? 0),
		roomRatingDescription: hotelData.GuestExperience?.SectionRatingDescription?.[0]?.Accomodations,
		beachRating: parseFloat(hotelData.GuestExperience?.SectionRating?.[0]?.Beach ?? 0),
		beachRatingDescription: hotelData.GuestExperience?.SectionRatingDescription?.[0]?.Beach,
		entertainmentRating: parseFloat(
			hotelData.GuestExperience?.SectionRating?.[0]?.Entertainment ?? 0
		),
		entertainmentRatingDescription:
			hotelData.GuestExperience?.SectionRatingDescription?.[0]?.Entertainment,
		serviceRating: parseFloat(hotelData.GuestExperience?.SectionRating?.[0]?.Service ?? 0),
		serviceRatingDescription: hotelData.GuestExperience?.SectionRatingDescription?.[0]?.Service,
		resortOverview: hotelData?.ResortOverview,

		overallRating: hotelData.GuestExperience?.OverallRating?.[0]?.OverallScore,
		overallRatingDescription: hotelData.GuestExperience?.OverallRating?.[0]?.OverallDescription,
	};

	return <PageBanner data={bannerData} price={price} locale={locale} />;
};

PageBannerConnector.propTypes = {
	hotelData: PropTypes.object,
	merchandising: PropTypes.array,
};

PageBannerConnector.defaultProps = {
	hotelData: null,
	merchandising: null,
};

export { PageBannerConnector };
